import React from 'react';
import { FederationMembersPage } from '../../components/FederationMembersPage';
const members = [{
  name: 'Ясинська Ганна',
  role: 'Президент федерації',
  email: 'head@umcf.org.ua'
}, {
  name: 'Казбеков Серік',
  role: 'Віце-президент федерації',
  email: 's.kazbekov@umcf.org.ua'
}, {
  name: 'Копейка Геннадій',
  role: 'Віце-президент федерації',
  email: 'genvkop@gmail.com'
}, {
  name: 'Полтавець Олександр',
  role: 'Член президії'
}, {
  name: 'Терзиул Ірина',
  role: 'Член президії'
}];
export function Presidia() {
  return <FederationMembersPage title="Президія" subtitle="Керівний орган Федерації Альпінізму і Скелелазіння України" members={members} data-id="element-781" />;
}